import { Badge } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { MLRunsDto } from 'api/Wallet/Types/MLRunsDto'
import { formatLocalDateUTC } from 'utils/date'

import styles from './MLRuns.module.scss'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const formatPayload = (payload: string): string => {
  try {
    return JSON.stringify(JSON.parse(payload), null, 2)
  } catch {
    return payload
  }
}

export const MLRunsColumns: GridColumn[] = [
  {
    title: 'Run ID',
    field: 'externalModelRunId',
    show: true,
    width: 100,
  },
  {
    title: 'Model',
    field: 'modelName',
    show: true,
    width: 200,
  },
  {
    title: 'Run Date',
    field: 'modelRunDate',
    show: true,
    width: 130,
  },
  {
    title: 'Timestamp',
    field: 'modelRunTimestamp',
    show: true,
    width: 170,
    cell: (props: GridCellProps): JSX.Element => {
      const run = props.dataItem as MLRunsDto
      return <td>{formatLocalDateUTC(run.modelRunTimestamp, true)}</td>
    },
  },
  {
    title: 'Risk',
    field: 'modelRisk',
    show: true,
    width: 110,
  },
  {
    title: 'Guardrail',
    show: true,
    width: 220,
    cell: (props: GridCellProps): JSX.Element => {
      const run = props.dataItem as MLRunsDto
      return (
        <td>
          <Badge variant={run.guardrailsFailed ? 'red' : 'green'}>
            {run.guardrailsFailed ? run.guardrailsResult.name : 'Passed'}
          </Badge>
        </td>
      )
    },
  },
  {
    title: 'Master Transaction',
    field: 'masterTransactionId',
    show: true,
    width: 250,
  },
  {
    title: 'Reference',
    field: 'referenceId',
    show: true,
    width: 170,
  },
  {
    title: 'Client',
    field: 'clientId',
    show: true,
    width: 250,
  },
  {
    title: 'Wallet',
    field: 'walletId',
    show: true,
    width: 250,
  },
  {
    title: 'Payload',
    show: true,
    width: 420,
    cell: (props: GridCellProps): JSX.Element => {
      const run = props.dataItem as MLRunsDto
      const formatted = formatPayload(run.payload)
      return (
        <td>
          <details className={styles.details}>
            <summary>
              <span>{formatted.slice(0, 80)}</span>
            </summary>
            <pre className='mt-2 max-h-[360px] overflow-auto whitespace-pre-wrap break-words bg-background p-2 text-xs'>
              {formatted}
            </pre>
          </details>
        </td>
      )
    },
  },
]
